<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("tipos-agenda") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("crm")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("tipos-agenda")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !tipoagendaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'ven-tipo-agenda-new',
                                    })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                            <div class="search-bar">
                                <search-bar
                                    :onSearch="debouncedOnSearch"
                                />
                            </div>

                        <div class="situacao-select">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                v-model="filters.situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="tipos"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                class="td-center"
                                :key="i"
                                :field="f.key"
                                :label="f.label ? $t(f.label) : ''"
                                :sortable="f.sortable"
                                :centered="f.centered"
                                :width="f.width"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'icone'">
                                    <!--gerando html com v-html par icones dinamicos -->
                                    <span
                                        v-if="props.row[f.key] != null"
                                        v-html="`<i class='fa-lg ${props.row[f.key]}'></i>`"
                                        ref="motivoDespesaIcon"
                                        class="icon has-text-dark"
                                    />
                                    <span v-else>---</span>
                                </div>
                                <div v-else-if="f.key == 'cor'">
                                    <div
                                        v-if="props.row[f.key] != null && props.row[f.key] !== 'Selecione uma cor'"
                                        class="color-block mt-1"
                                        :style="{
                                            'background-color': props.row[f.key],
                                        }"
                                    />
                                    <span v-else>---</span>
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'ven-tipo-agenda-edit',
                                            params: {
                                                id: props.row.id,
                                            },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'codigo'">
                                    {{ props. row[f.key] }}
                                </div>
                                <div v-else-if="f.key == 'excluir' && !tipoagendaIntegracao" >
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(
                                                props.row
                                            )
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        v-if="props.row[f.key] == 1"
                                        class="table-tag table-tag-full-width"
                                        type="is-success"
                                        size="is-medium"
                                    >
                                        {{ $t("ativo") }}
                                    </b-tag>
                                    <b-tag
                                        v-else
                                        class="table-tag table-tag-full-width"
                                        type="is-danger"
                                        size="is-medium"
                                    >
                                        {{ $t("inativo") }}
                                    </b-tag>
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import TipoAgendaAtividadeService from "@/services/TipoAgendaAtividadeService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("ven-tipo-agenda") &&
            to.name != "ven-tipo-agenda-list"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            tipoagendaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                "TIPOAGENDAATIVIDADE"
            ),
            tipos: [],
            service: new TipoAgendaAtividadeService(this.$http, this.$router),
            fields: [
                { key: "codigo", label: "codigo", width: 20, sortable: true },
                { key: "icone", width: 70, sortable: false, sortFn: null },
                { key: "cor", width: 70, sortable: false, sortFn: null },
                { key: "descricao", label: "descricao", sortable: true },
                { key: "situacao", label: "situacao", width: 70, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            filters: {
                situacao: { id: 2, label: "todos" },
            },
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            delete: null,
            column: "descricao",
            order: "asc",
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if (["ven-tipo-agenda-new", "ven-tipo-agenda-edit"].includes(this.$route.name)) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "crm",
            "ven-tipo-agenda"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tipos-atividade" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.filters.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.tipos = value;
                    this.isEmpty = this.tipos.length <= 0;
                })
                .catch((e) => {
                    console.error("Erro ao carregar tipo de agenda.", e);
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idtipoagendaatividadeerp,
                    descricao: m.descricao,
                    cor: m.cor,
                    icone: m.icone != null ? m.icone.toLowerCase() : null,
                    situacao: m.situacao,
                    excluir: "excluir",
                    replicapda: m.replicapda,
                };
            });
            return list;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },

        /**
         * Função chamada quando a situação é alterada.
         * Atualiza o filtro de situação e carrega os dados novamente.
         *
         * @param {Object} val - O valor selecionado da situação.
         */
        onSituacaoChanged(val) {
            this.filters.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },

        promptForDelete(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-exclusao-n", { n: row.descricao }),
                onConfirm: this.excluir,
                onCancel: this.removePrompt,
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n",
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1
                        ? "msg-erro-ao-desativar"
                        : "msg-erro-ao-reativar",
                    { n: this.$t("tipo-agenda") }
                );
            let tipoagenda = {
                idtipoagendaatividade: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
                replicapda: this.delete.replicapda,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tipoagenda)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? "msg-sucesso-ao-reativar"
                                    : "msg-sucesso-ao-desativar",
                                { n: this.$t("tipo-agenda") }
                            );
                        this.$root.showMessage(
                            "success",
                            tempSuccess,
                            true,
                            false
                        );
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        excluir() {
            let item = this.delete;
            this.isLoading = true;
            this.service
                .delete(item.id)
                .then((_) => {
                    this.$root.showMessage(
                        "success",
                        "msg-success-excluir-tipo-agenda-atividade"
                    );
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error("Erro ao excluir tipo de atividade.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-failure-excluir-tipo-agenda-atividade"
                    );
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.delete = null;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    // min-height: calc(100% - 50px);
    // position: relative;

    // h1.title {
    //     padding-top: 0px;
    //     margin-bottom: 0 !important;
    // }

    .page {
        position: relative;
        padding-left: 0;

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .situacao-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>